<template>
  <div id="dashboard-content" class="content-section" v-loading="loadingFull"
       element-loading-text="拼命加载中"
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">
    <h2 class="page-title">控制面板</h2>
    <p>欢迎回来！以下是您的业务概览。</p>

    <div class="features" style="margin-top: 30px;">
      <div class="feature-card">
        <i class="el-icon-folder-opened"></i>
        <h3>案件总数</h3>
        <p style="font-size: 32px; color: #1a3a6c; font-weight: bold;">{{info.CaseCount || 0}}</p>
        <p>进行中: {{info.CaseingCount || 0}} | 已完成: {{info.CaseDownCount || 0}}</p>
      </div>

      <div class="feature-card">
        <i class="el-icon-present"></i>
        <h3>累计佣金</h3>
        <p style="font-size: 32px; color: #28a745; font-weight: bold;">¥{{info.Commission || 0}}</p>
        <p>本月佣金: ¥{{info.CommissionByMonth || 0}}</p>
      </div>

      <div class="feature-card">
        <i class="el-icon-s-custom"></i>
        <h3>代理团队</h3>
        <p style="font-size: 32px; color: #ffc107; font-weight: bold;">{{info.AgentCount || 0}}</p>
        <p>本月新增: {{info.AgentCountByMonth || 0}}</p>
      </div>

      <div class="feature-card">
        <i class="el-icon-s-data"></i>
        <h3>推广效果</h3>
        <p @click="turnTo('/My/Agent')" style="font-size: 32px; color:#dc3545; font-weight: bold;cursor: pointer">{{info.TGAcoount || 0}}</p>
        <p>通过推广链接注册</p>
      </div>
    </div>
    <!--<div style="margin-top: 40px;">-->
      <!--<h3 style="color: #1a3a6c; margin-bottom: 15px;">快速操作</h3>-->
      <!--<div class="action-buttons">-->
        <!--<button class="btn btn-primary">提交新案件</button>-->
        <!--<button class="btn btn-success">查看推广码</button>-->
        <!--<button class="btn btn-warning">查询佣金</button>-->
      <!--</div>-->
    <!--</div>-->
  </div>
</template>

<script>

export default {
  data() {
    return {
      url: {
        GetControlPanel: SZH.assets.api + '/Custom/GetControlPanel',
      },
      loadingFull:false,
      info:{}
    }
  },
  methods: {
    turnTo(url){
      let self = this;
      self.$router.push({
        path: url
      });
    },
    getData(){
      let self = this;
      self.loadingFull = true;
      self.$http.post(self.url.GetControlPanel,{ })
        .then(result => {
          if (result.state == true) {
            self.info = result.data;
            self.loadingFull = false;
          } else {
            self.info = {};
            self.loadingFull = false;
            self.$message.error(result.message);
          }
        }, () => {
          self.loadingFull = false;
          // 请求失败
          self.$message.error('请求失败，请检查您的网络是否可用。');
        });
    },
  },
  computed: {},
  components: {
  },
  mounted() {
    this.getData();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Me/ControlPanel/ControlPanel.vue